import Vue from 'vue';
import App from './App.vue';
import VueMask from 'v-mask';

import './scss/fonts.scss';
import './scss/global.scss';
import './scss/buttons.scss';

import vuetify from './plugins/vuetify';
import router from './router';
import store from './store/store.js';

Vue.use(VueMask);

new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
